import {AutocompleteComponent, AutocompleteLoadingModeType, IAutocompleteSchema, IDatepickerSchema, ToastService} from "maps-angular-components";
import {Component, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";

import {Associacao} from "../../associacao-stepper/associacao";
import {AssociacaoService} from "../../associacao-stepper/associacao.service";
import {Carteira, CarteiraAutocompleteModel} from "../../../carteira/carteira.model";
import {CarteiraService} from "../../../carteira/carteira.service";
import {DatePipe} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {ModalDeletarAssociacaoDialogComponent} from "./modal-deletar-associacao/modal-deletar-associacao.component";
import {Regra} from "../../../regra/regra";
import {RegraService} from "../../../regra/regra.service";
import {Subject, Subscription} from "rxjs";
import {TipoExecucao} from "../../../resultado-regra/resultado-regra/tipo-execucao";
import {indicate} from "../../../shared/util/loading-indicate";
import {BrowserSupport} from "../../../shared/util/browser-support";
import { CarteiraGrupoAutocompleteService } from "src/app/carteira/carteira-grupo-autocomplete.service";

@Component({
  selector: "app-associacao-gerenciador",
  templateUrl: "./associacao-gerenciador.component.html",
  styleUrls: ["./associacao-gerenciador.component.scss"],
})
export class AssociacaoGerenciadorComponent implements OnInit {

  private readonly subscriptions = new Subscription();

  form: FormGroup;

  tiposExecucao = TipoExecucao.getTiposExecucao;

  @ViewChild("carteiraAutocomplete", { static: false })
  private readonly carteiraAutocomplete: AutocompleteComponent<CarteiraAutocompleteModel>;

  @ViewChild("regraAutocomplete", { static: false })
  private readonly regraAutocomplete: AutocompleteComponent<Regra>;

  associacoes: Associacao[] = [];
  associacaoEdicao: Associacao;
  associacaoOriginal: Associacao;

  loading$ = new Subject<boolean>();
  loadingExport$: Subject<boolean> = new Subject<boolean>();
  showExecutar = false;

  page$: Subject<number> = new Subject<number>();

  paginationTotalPage = 1;

  private pageNumber = 20;

  totalRegistros = 0;

  regraSchema: IAutocompleteSchema<Regra>;

  carteiraSchema: IAutocompleteSchema<CarteiraAutocompleteModel>;

  dataInicioSchema: IDatepickerSchema;

  dataFimSchema: IDatepickerSchema;

  dataInicioSchemaEdit: IDatepickerSchema;

  private totalPages: number;
  private readonly allElements: Associacao[] = [];
  private readonly totalElements: number;
  private dataSource: Associacao[];
  private paginatedDataSource: Associacao[][];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly messageService: ToastService,
    private readonly service: AssociacaoService,
    private readonly dialog: MatDialog,
    private readonly regraService: RegraService,
    private readonly carteiraService: CarteiraService,
    private readonly datePipe: DatePipe,
    private readonly carteiraGrupoAutocompleteService: CarteiraGrupoAutocompleteService
  ) {}

  ngOnInit() {
    this.page$.subscribe((value) =>
      this.form.controls["page"].setValue(value - 1)
    );

    this.form = this.formBuilder.group({
      carteiraId: new FormControl(),
      regra: new FormControl(),
      dataInicio: new FormControl(),
      dataFim: new FormControl(),
      tipoExecucao: new FormControl(),
      page: new FormControl(0),
    });
    this.regraSchema = {
      service: this.regraService,
      endpoint: "autocomplete/associacao",
      label: "Regra (Regra Simples / Regra Composta)",
      placeholder: "Regra selecionada",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      formGroup: this.form,
      formControlName: "regra",
      panelClass: "w-100",
      parseSearchParam(search): string {
        return search;
      },
    };
    this.carteiraSchema = {
      service: this.carteiraGrupoAutocompleteService,
      label: "",
      placeholder: "",
      loadingMode: AutocompleteLoadingModeType.LAZY,
      autoload: false,
      endpoint: "",
      formGroup: this.form,
      formControlName: "carteiraId",
      panelClass: "large-input",
      parseSearchParam(search): string {
        return search;
      },
    };
    this.dataInicioSchema = {
      label: "Data início",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      required: false,
      panelClass: "w-100",
      formControlName: "dataInicio",
    };
    this.dataFimSchema = {
      label: "Data fim",
      placeholder: "Selecione uma data",
      formGroup: this.form,
      required: false,
      panelClass: "w-100",
      formControlName: "dataFim",
    };
  }

  pesquisar(form: FormGroup) {
    this.associacoes = [];
    this.showExecutar = true;
    this.service
      .search(form.value, this.pageNumber)
      .pipe(indicate(this.loading$))
      .subscribe(
        (res) => {
          if (res.metadata.totalElements > 0) {
            if (res.metadata.size === 0) {
              this.paginationTotalPage = 1;
            } else {
              this.paginationTotalPage = Math.ceil(
                res.metadata.totalElements / res.metadata.size
              );
            }
            this.totalRegistros = res.metadata.totalElements;
            this.associacoes = res.content.map((e) =>
              Object.assign(new Associacao(), e)
            );
            this.associacoes.forEach(assoc => {
             assoc.inicio = this.datePipe.transform(assoc.inicio,'dd/MM/yyyy');
             assoc.fim = this.datePipe.transform(assoc.fim,'dd/MM/yyyy')
            });

            this.form.get("page").setValue(res.metadata.number);
          } else {
            this.paginationTotalPage = 1;
          }
        },
        (err) => this.messageService.erro(err.error.message)
      );
  }

  setModoEdicao(a) {
    this.associacaoOriginal = a ? { ...a } : null;
    this.associacaoEdicao = a ? { ...a } : null;
  }

  associacaoIsEqual(a: Associacao, b: Associacao): boolean {
    return a && b && a.carteiraId === b.carteiraId && a.regraId === b.regraId;
  }

  limpar() {
    this.associacoes = [];
    this.regraAutocomplete.reset();
    this.carteiraAutocomplete.reset();
    this.form.reset();
  }

  save() {
    this.service
      .editarAssociacao(
        this.associacaoEdicao.carteira,
        this.associacaoEdicao.regra,
        {
          processamentoOnlineAtivo: this.associacaoEdicao.processamentoOnlineAtivo,
          inicio: (this.associacaoEdicao.inicio + "")
            .substr(0, 10)
            .split("/")
            .reverse()
            .join("-"),
          fim: (this.associacaoEdicao.fim + "")
            .substr(0, 10)
            .split("/")
            .reverse()
            .join("-"),
        }
      )
      .pipe(indicate(this.loading$))
      .subscribe(
        (res) => {
          this.associacoes = this.associacoes.map((a) =>
            this.associacaoIsEqual(a, this.associacaoOriginal)
              ? this.associacaoEdicao
              : a
          );
          this.setModoEdicao(null);
        },
        (err) => {
          this.messageService.erro(err.error.message || err.message);
          this.setModoEdicao(null);
        }
      );
  }

  onChangeTotalPagina(e) {
    this.pageNumber = e;
    this.page$.next(1);
    this.pesquisar(this.form);
  }

  openDeleteDialog(associacao: Associacao) {
    const dialogRef = this.dialog.open(ModalDeletarAssociacaoDialogComponent, {
      data: associacao,
      width: "800px",
    });
    dialogRef.componentInstance.deletar.subscribe(() =>
      this.pesquisar(this.form)
    );
  }

  updatePageSize(pageSize: number) {
    this.pageNumber = pageSize;
    this.totalPages = this.totalElements / pageSize;
    this.paginatedDataSource = this.breakIntoChunks(
      this.allElements,
      this.pageNumber
    );
    this.dataSource = this.paginatedDataSource[0];
    this.paginationTotalPage = 1;
    this.page$.next(1);
  }

  private breakIntoChunks(array, chunk) {
    const temparray = [];
    for (let i = 0, j = 0; i < array.length; j++, i += chunk) {
      temparray[j] = array.slice(i, i + chunk);
    }
    return temparray;
  }

  receiverPage(value: any) {
    this.page$.next(value);
    this.pesquisar(this.form);
  }

  getTipoExecucao(processamentoOnlineAtivo: any) {
    if (processamentoOnlineAtivo) {
      return "Sim";
    } else {
      return "Não";
    }
  }

  compareFunctionObjects(object1: any, object2: any) {
    return object1 && object2 && object1.name === object2.name;
  }

  exportarPdf() {
    this.subscriptions.add(
      this.service.exportPdf(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.savePDF(data);
      }, err => this.messageService.erro(err.error.message)));
  }

  exportarXls() {
    this.subscriptions.add(
      this.service.exportXlsx(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.saveXlsx(data);
      }, err => this.messageService.erro(err.error.message)));
  }
}
